import React, { useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getMedicalRecords } from "../../Redux/Slice/MedicalRecord";

const PatientRecordsPage = () => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.record);
  const records = items?.data || [];

  useEffect(() => {
    dispatch(getMedicalRecords());
  }, [dispatch]);

  return (
    <Box sx={{ padding: "2rem" }}>
      <Typography variant="h5" gutterBottom>
        Patient Records
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Previous medical history and visit summaries.
      </Typography>

      <Box mt={3}>
        {records.length === 0 ? (
          <Typography>No patient records found.</Typography>
        ) : (
          records.map((record) => (
            <Paper key={record.visitTableId} sx={{ p: 2, mb: 3 }}>
              <Typography variant="subtitle1" fontWeight={600}>
                Visit Date: {record.visitDate?.split(" ")[0]}
              </Typography>
              <Typography variant="body2">
                Patient: {record.patientName} | Doctor: {record.doctorName} (
                {record.specialityName})
              </Typography>

              <Box mt={1}>
                <Typography variant="subtitle2" fontWeight={500}>
                  Chief Complaints:
                </Typography>
                {record.chiefComplaints?.length > 0 ? (
                  record.chiefComplaints.map((cc) => (
                    <Typography key={cc.chiefComplaintId} variant="body2">
                      - {cc.chiefComplaint} ({cc.duration} days)
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    None recorded.
                  </Typography>
                )}
              </Box>

              <Box mt={1}>
                <Typography variant="subtitle2" fontWeight={500}>
                  Diagnosis:
                </Typography>
                {record.diagnosis?.length > 0 ? (
                  record.diagnosis.map((d) => (
                    <Typography key={d.diagnosisId} variant="body2">
                      - {d.diagnosis} ({d.category})
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    None recorded.
                  </Typography>
                )}
              </Box>
            </Paper>
          ))
        )}
      </Box>
    </Box>
  );
};

export default PatientRecordsPage;
